// extracted by mini-css-extract-plugin
export default {"pointOfContact":"sSLo_IDDkIekdZi39Cpz","message":"FLc26dSklPOno4Bk_p_2","iconWrapper":"bzz_9CCxBHFgu3fU7Q7O","divider":"D70XOmSUe2E9XZPvu2P6","contactInfo":"SJCSq5hRwinR5AiiYy1A"};